import { BASE_ENDPOINT } from "../../../endpoint";

export const retrieveCustomerService = async (token: string, customerId: string, signal?: any) => {
    try {
        const response = await fetch(`${BASE_ENDPOINT}/user/customerservice/customer/${customerId}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            signal: signal
        });
        const res = await response.json();
        if (!response.ok) {
            console.error('Error:', res);
            throw new Error(res.message);
        }
        return res.data;
    } catch (error) {
        console.error('API fetch error:', error);
        throw error;
    }
};
